module.exports = __webpack_public_path__ + "img/dry-hairy-tree-00.183b593f.png";